import { Component, OnInit } from '@angular/core';
import { AssessmentService } from 'app/shared/services/assessment.service';
import { AssessmentResult } from 'app/shared/models/assessment-result';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'dac-client-assessment-result-view',
  templateUrl: './client-assessment-result-view.component.html',
  styleUrls: ['./client-assessment-result-view.component.scss']
})
export class ClientAssessmentResultViewComponent implements OnInit {
  _clientId: any;
  hasLoadedResults: boolean;
  result: AssessmentResult;

  constructor(private _assessmentService:AssessmentService, private route:ActivatedRoute) { }

  ngOnInit() {
   // TODO: stephen do we need the rx switchTo piece?
   this.route.params.subscribe((params) => {
    this._clientId = params['id'];
    let resultId = params['resultId'];
    this.hasLoadedResults = false;
    this._assessmentService.getAssessmentResult(this._clientId, resultId).then((result:AssessmentResult) =>  {
      this.hasLoadedResults = true;
      this.result = result;
      if (this.result == null || !this.result.scaleResults || this.result.scaleResults.length < 1) {
        console.error("Could not find result");
        // this.goBack();
      }
    })
    .catch((error) => {
      console.error(error);
      if (error && error.status === 404 || error.status === 400) {
        // this.goBack();
      }
    });
  });
}

ngAfterViewInit() {
  // we need to let outside listeners like the server pdf generator know we have finished loading so we can generate the report
  console.log("adding dac-report-loaded class");
  document.body.classList.add("dac-report-loaded");
}

}



// WEBPACK FOOTER //
// ./src/app/reports/client-assessment-result-view/client-assessment-result-view.component.ts